export default __webpack_public_path__ + "static/media/md.44ba19a1.jpg";